const popupInstances = new Map();

export function registerPopupInstance(id, instance) {
  if (!id || !instance) {
    return;
  }

  popupInstances.set(String(id), instance);
}

function getPopupGuardApiForElement(element) {
  const popupRoot = element?.closest?.('[id^="elementor-popup-modal-"]');

  if (!popupRoot) {
    return null;
  }

  const popupId = popupRoot.id.replace("elementor-popup-modal-", "");
  const instance = popupInstances.get(popupId);
  const candidates = [
    instance,
    instance?.getModal?.(),
    instance?.modal,
    instance?.lightbox,
  ].filter(Boolean);

  for (const target of candidates) {
    if (
      typeof target?.getSettings === "function" ||
      typeof target?.option === "function" ||
      typeof target?.setSettings === "function" ||
      typeof target?.setOption === "function" ||
      typeof target?.settings === "object"
    ) {
      return target;
    }
  }

  return null;
}

function getPopupOption(target, key) {
  if (typeof target?.getSettings === "function") {
    return target.getSettings(key);
  }

  if (typeof target?.getOption === "function") {
    return target.getOption(key);
  }

  if (typeof target?.option === "function") {
    return target.option(key);
  }

  return target?.settings?.[key];
}

function setPopupOption(target, key, value) {
  if (typeof target?.setSettings === "function") {
    target.setSettings(key, value);
    return true;
  }

  if (typeof target?.setOption === "function") {
    target.setOption(key, value);
    return true;
  }

  if (typeof target?.option === "function") {
    target.option(key, value);
    return true;
  }

  if (target?.settings && typeof target.settings === "object") {
    target.settings[key] = value;
    return true;
  }

  return false;
}

export function disablePopupEscapeClose(element) {
  const target = getPopupGuardApiForElement(element);

  if (!target) {
    return null;
  }

  const keys = [
    "closeOnEscape",
    "closeOnEsc",
    "hideOnEsc",
    "close_on_esc",
  ];
  const previous = {};
  let hasKnownSetting = false;

  keys.forEach((key) => {
    const value = getPopupOption(target, key);

    if (typeof value === "undefined") {
      return;
    }

    previous[key] = value;
    hasKnownSetting = true;

    if (value !== false) {
      setPopupOption(target, key, false);
    }
  });

  if (!hasKnownSetting) {
    return null;
  }

  return () => {
    keys.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(previous, key)) {
        setPopupOption(target, key, previous[key]);
      }
    });
  };
}
